import { useState } from "react";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { Calendar as CalendarIcon } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

export default function DatePicker({ value, onChange, testid, minDate }) {
  const [open, setOpen] = useState(false);
  const selected = value ? new Date(value) : undefined;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          className="w-full flex items-center gap-2 rounded-xl border border-slate-300 px-3 py-2 text-left text-sm mt-1 hover:border-sky-400 transition-colors"
        >
          <CalendarIcon className="w-4 h-4 text-slate-400" />
          {selected ? format(selected, "d MMMM yyyy", { locale: fr }) : <span className="text-slate-400">Choisir une date</span>}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0 rounded-2xl" align="start">
        <Calendar
          mode="single"
          selected={selected}
          onSelect={(d) => {
            if (d) onChange(format(d, "yyyy-MM-dd"));
            setOpen(false);
          }}
          disabled={minDate ? { before: minDate } : undefined}
          defaultMonth={minDate}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
